import { useState, useEffect, useRef } from "react";
import axios from "../../../lib/axios";
import { ADMIN_ORDER_FIND_MANY } from "../../../lib/endpoints/order";
import { DEFAULT_ROWS_PER_PAGE } from "../../../config-global";
import { OrderStatusEnum } from "../../../enums/orderStatus";
import { convertOrderStatusEnumToStatusCode } from "../../../utils/convertOrderStatusValue";
import { OrderModel } from "../../../models/order";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { MerchantUserModel } from "../../../models/merchantUser";
// ---------------------------------------------------

const useReturnOrderController = () => {
  // ----------------- variables ------------------
  const authData: MerchantUserModel =
    useSelector((state: RootState) => state?.auth?.data) || null!;
  const [data, setData] = useState([]);

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingGetData, setLoadingGetData] = useState<boolean>(false);
  const [loadingFetchDataMore, setLoadingFetchDataMore] =
    useState<boolean>(false);
  const searchRef = useRef<HTMLInputElement>(null!);
  const [openMenu, setOpenMenu] = useState(null);
  const [selectedId, setSelectedId] = useState<string>(null!);
  const [selectedData, setSelectedData] = useState<OrderModel>(null!);
  const [currentOrderStatus, setCurrentOrderStatus] = useState<OrderStatusEnum>(
    OrderStatusEnum.Shipping
  );

  // ----------------- functions --------------------

  const handleGetData = async () => {
    try {
      setLoading(true);
      console.log( `${ADMIN_ORDER_FIND_MANY}?StatusCodeAdmin=${convertOrderStatusEnumToStatusCode(
        OrderStatusEnum.Shipping
      )}`);
      console.log( {
        filter: {
          merchantId: authData?.merchantId,
        },
      })
      const res = await axios.post(
        `${ADMIN_ORDER_FIND_MANY}?StatusCodeAdmin=${convertOrderStatusEnumToStatusCode(
          OrderStatusEnum.Shipping
        )}`,
        {
          filter: {
            merchantId: authData?.merchantId,
          },
        }
      );
      console.log('res=',res);
      setData(res?.data);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const handleGetDataByOrderStatus = async (getId: OrderStatusEnum) => {
    try {
      setLoadingGetData(true);
      const res = await axios.post(
        `${ADMIN_ORDER_FIND_MANY}?StatusCodeAdmin=${convertOrderStatusEnumToStatusCode(
          getId
        )}`,
        {
          filter: {
            merchantId: authData?.merchantId,
          },
        }
      );
      setData(res?.data);
    } catch (err) {
    } finally {
      setLoadingGetData(false);
    }
  };

  const handleRefetchData = async () => {
    try {
      const res = await axios.post(
        `${ADMIN_ORDER_FIND_MANY}?StatusCodeAdmin=${convertOrderStatusEnumToStatusCode(
          currentOrderStatus
        )}`,
        {
          filter: {
            merchantId: authData?.merchantId,
          },
        }
      );
      setData(res?.data);
    } catch (err) {
    } finally {
    }
  };

  const handleGetDataByOrderId = async () => {
    try {
      setLoadingGetData(true);
      const res = await axios.post(ADMIN_ORDER_FIND_MANY, {
        filter: {
          merchantId: authData?.merchantId,
          orderNo: searchRef.current.value,
        },
      });
      
      setCurrentOrderStatus(null!);
      setData(res?.data?.filter((item:OrderModel)=>item?.status?.code===convertOrderStatusEnumToStatusCode(OrderStatusEnum.Shipping)));
    } catch (err) {
    } finally {
      setLoadingGetData(false);
    }
  };

  const handleCurrentOrderStatusChange = (newValue: OrderStatusEnum) => {
    if (newValue) {
      setCurrentOrderStatus(newValue);
      handleGetDataByOrderStatus(newValue);
    }
  };

  const handleOpenMenu = (event: any, getId: string) => {
    setOpenMenu(event.currentTarget);
    setSelectedId(getId);
    // setSelectedData(data?.filter((item: any) => item?.id === getId)[0]);
  };

  const handleFetchDataMore = () => {};

  const handlePageChange = (event: any, newPage: any) => {
    if (newPage === countPagination) {
      if (!loadingFetchDataMore) {
        handleFetchDataMore();
      }
    }
    setCurrentPage(newPage);
  };

  const handleCloseMenu = () => {
    setOpenMenu(null);
  };

  const handleOpenForm = () => {
    setOpenMenu(null);
    setOpenForm(true);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setSelectedData(null!);
  };

  const handleClickViewData = () => {
    setOpenForm(true);
    setSelectedData(data?.filter((item: any) => item?.id === selectedId)[0]);
    setOpenMenu(null);
  };

  // ----------------- useEffect --------------------

  const filterData=data?.filter((item:OrderModel)=>item?.remarkFromRider);

  const rows = filterData.slice(
    (currentPage - 1) * DEFAULT_ROWS_PER_PAGE,
    currentPage * DEFAULT_ROWS_PER_PAGE
  );
  console.log('filterData=',filterData)
  console.log('rows=',rows)
  // const rows=data;
  const countPagination = Math.ceil(data.length / DEFAULT_ROWS_PER_PAGE);

  //   const isSearchNotFound: boolean = !data.length;

  useEffect(() => {
    handleGetData();
  }, []);

  return {
    data,
    loading,
    rows,
    countPagination,
    openForm,
    searchRef,
    handleGetDataByOrderId,
    currentPage,
    loadingFetchDataMore,
    handleOpenMenu,
    handlePageChange,
    openMenu,
    handleCloseMenu,
    handleOpenForm,
    handleCloseForm,
    handleClickViewData,
    selectedData,
    currentOrderStatus,
    handleCurrentOrderStatusChange,
    loadingGetData,
    handleRefetchData,
    // isSearchNotFound,
  };
};
export default useReturnOrderController;
